import { fieldEntryHasPresentableValue } from '@/common/utils/changedDataFieldMerge'
import { unwrapScriptValue } from '@/common/utils/wrapScriptValue'

const PAGE_FIELD_SCALAR_TYPES = new Set(['HTML', 'SVG', 'VIDEOPLAYER'])

export function isPageFieldScalarElementType(type: string | undefined | null): boolean {
  return PAGE_FIELD_SCALAR_TYPES.has(String(type ?? '').trim().toUpperCase())
}

/** Scalar string from pageFields when form registry has no value yet (HTML/SVG/VIDEOPLAYER). */
export function resolveElementPageFieldScalar(
  pageFields: Record<string, unknown> | undefined,
  fieldName: string,
): string | null {
  if (!fieldName.trim()) return null
  const pageEntry = pageFields?.[fieldName]
  if (pageEntry && typeof pageEntry === 'object' && !Array.isArray(pageEntry) && 'value' in pageEntry) {
    const raw = (pageEntry as { value?: unknown }).value
    if (raw !== undefined && raw !== null) {
      const text = String(unwrapScriptValue(raw))
      return text.trim() === '' ? null : text
    }
  }
  if (fieldEntryHasPresentableValue(pageEntry)) {
    if (typeof pageEntry === 'string') return pageEntry
    return String(unwrapScriptValue(pageEntry))
  }
  return null
}
